import { render, staticRenderFns } from "./SharingChatGPT.vue?vue&type=template&id=54195cf2&scoped=true&"
import script from "./SharingChatGPT.vue?vue&type=script&lang=js&"
export * from "./SharingChatGPT.vue?vue&type=script&lang=js&"
import style0 from "./SharingChatGPT.vue?vue&type=style&index=0&id=54195cf2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54195cf2",
  null
  
)

export default component.exports